import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getIPAddress } from '../../actions/navigation';

// eslint-disable-next-line
const withIPAddress = (WrappedComponent, options = {}) => {
  const HOC = (props) => {
    const [ipAddress, setIpAddress] = useState(null);

    useEffect(() => {
      props.getIPAddress({
        success: (ipResponse) => {
          setIpAddress(ipResponse.ip);
        },
        fail: (err) => {
          console.log('Getting IP address failed', err);
        },
      });
    }, []);

    useEffect(() => {
      props.getIPAddress({
        success: (ipResponse) => {
          setIpAddress(ipResponse.ip);
        },
        fail: (err) => {
          console.log('Getting IP address failed', err);
        },
      });
    }, [props.location]);

    return ipAddress
      ? <WrappedComponent {...props} ipAddress={ipAddress} />
      : <div />;
  };

  HOC.propTypes = {
    getIPAddress: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
  };

  return connect(null, { getIPAddress })(HOC);
};

export default withIPAddress;
